import { NameSearchMode } from '@neptune/shared/search-domain';

export function getDefaultMode(_regexFilter?: string, substringFilter?: string) {
  const defaultRegex = substringFilter != null ? NameSearchMode.SUBSTRING : NameSearchMode.REGEX;
  return defaultRegex;
}
